import { onUnmounted, ref } from 'vue';

type PaymentStatus = 'pending' | 'confirmed' | 'captured' | 'failed' | 'partial_failure';

export function useTransactionSSE(getEventsUrl: () => string) {
  const paymentStatus = ref<PaymentStatus>('pending');
  const failedBookingIds = ref<string[]>([]);
  const failureReasons = ref<Record<string, string>>({});
  let eventSource: EventSource | null = null;

  function connect() {
    disconnect();
    paymentStatus.value = 'pending';
    failedBookingIds.value = [];
    failureReasons.value = {};

    eventSource = new EventSource(getEventsUrl(), { withCredentials: true });

    eventSource.addEventListener('PAYMENT_CONFIRMED', () => {
      paymentStatus.value = 'confirmed';
    });

    eventSource.addEventListener('PAYMENT_CAPTURED', () => {
      paymentStatus.value = 'captured';
      disconnect();
    });

    eventSource.addEventListener('PAYMENT_FAILED', () => {
      paymentStatus.value = 'failed';
      disconnect();
    });

    eventSource.addEventListener('BOOKINGS_PARTIALLY_FAILED', (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);
        failedBookingIds.value = data.failedBookingIds ?? [];
        failureReasons.value = data.failureReasons ?? {};
      }
      catch {
        failedBookingIds.value = [];
        failureReasons.value = {};
      }
      paymentStatus.value = 'partial_failure';
    });

    eventSource.onerror = () => {
      if (eventSource?.readyState === EventSource.CLOSED) {
        disconnect();
      }
    };
  }

  function disconnect() {
    eventSource?.close();
    eventSource = null;
  }

  onUnmounted(() => {
    disconnect();
  });

  return { paymentStatus, failedBookingIds, failureReasons, connect, disconnect };
}
